import { Component, OnInit, Inject, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl} from '@angular/forms';
import { UsersService } from '../../../pages/users/users.service';
import { GeneralService } from '../../services/general.service';
import { Institution } from './institution.model';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-select-institution',
  templateUrl: './select-institution.component.html',
  styleUrls: ['./select-institution.component.scss'],
  providers: [ UsersService, GeneralService ]
})
export class SelectInstitutionComponent implements OnInit {
  @Input() public data: Institution[];
  public instCtrl = new FormControl();
  @Output() public onChange: EventEmitter<any> = new EventEmitter<any>();

  constructor(private usersService: UsersService, private generalService: GeneralService) {

  }

  ngOnInit() {
    if(this.data) return;
    
    this.generalService.getInstitution(AuthService.getUser().business ? AuthService.getUser().business.name : 'notavailable').subscribe(insts => {
      this.data = insts;
    });
  }

  change(e) {
    console.log(e);
    this.onChange.emit(e);
  }

}
